import { app } from "../serviceLMS";
import { GET_QUIZ_BY_COURSE, GET_QUIZ_BY_ID, CREATE_QUIZ_ATTEMPT, GET_QUIZ_QUESTIONS_FOR_ATTEMPT, SUBMIT_QUIZ } from "../URLs"

export const fetchQuizByCourse = async (courseId) => {
  try {
    const res = await app.get(GET_QUIZ_BY_COURSE(courseId));
    return res.data?.data || null;
  } catch (error) {
    throw new Error(error?.response?.data?.message || error.message || "Failed to load quiz.");
  }
};



export const startQuizAttempt = async (quizId, userId) => {
  try {
    const res = await app.post(CREATE_QUIZ_ATTEMPT, { quizId, userId });
    return res.data;
  } catch (error) {
    console.error("API Error starting quiz attempt:", error);
    throw new Error(error?.response?.data?.message || "Failed to start quiz attempt.");
  }
};

export const fetchQuestionsForAttempt = async (quizId, attempt, userId) => {
  try {
    const res = await app.get(GET_QUIZ_QUESTIONS_FOR_ATTEMPT(quizId, attempt, userId));
    return res.data?.data || [];
  } catch (error) {
    console.error("API Error fetching questions:", error);
    throw new Error(error?.response?.data?.message || "Failed to load quiz questions.");
  }
};



export const submitQuizAttempt = async (attemptId, payload) => {
  try {
    const res = await app.post(SUBMIT_QUIZ(attemptId), payload);
    return res.data?.data || null;
  } catch (error) {
    console.error("API Error submitting quiz:", error);
    throw new Error(error?.response?.data?.message || "Failed to submit quiz.");
  }
};